import { Component, Input, OnInit } from '@angular/core';
import { BaseCellStepper } from '../model';
import { RowCell, Section } from '@urbannex/storethemes';
import { GridCell } from '../../../../home-page/home-input/home-input-grid/grid-input-dialog/section-gridcell-templates';
import { NbDialogService } from '@nebular/theme';
import { ConfigurationService } from '@urbannex/configuration';
import { OfbizFormsService } from '@urbannex/ofbiz-forms';
import { SectionBuilderStoreService } from '../../section-builder-store.service';

@Component({
  selector: 'kve-feature-cell-stepper',
  templateUrl: './feature-cell-stepper.component.html',
  styleUrls: ['./feature-cell-stepper.component.scss']
})
export class FeatureCellStepperComponent extends BaseCellStepper implements OnInit{
  @Input() cell:GridCell|RowCell;
  @Input() section:Section;

  constructor(
    //ref: NbDialogRef<SectionCellStepperComponent>,
    dialogService:NbDialogService,
    ofbizFormsService:OfbizFormsService,
    sectionBuilderStoreService:SectionBuilderStoreService,
    configurationService:ConfigurationService){
    super(dialogService,ofbizFormsService,sectionBuilderStoreService,configurationService)
  }

  ngOnInit(): void {
    console.log(this.cell);
    this.sectionBuilderStoreService.updateSelectedCell(this.cell);
    this.contentEnum = this.cell.contentEnum;
    console.log(this.contentEnum)
    this.stepperTitle = this.getStepperTitle(this.contentEnum)
    this.contentElements = this.cell.contentElements;
    this.baseUrl = this.configurationService.getBaseUrl();
  }

}
